"use client";

import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { createPrivateChat, CreatePrivateChatRequest } from "@/api";
import { useChatStore } from "@/stores";

const useCreatePrivateChat = () => {
  const { push } = useRouter();

  const setCurrentChat = useChatStore((state) => state.actions.setCurrentChat);
  const changeChatMobileView = useChatStore((state) => state.actions.changeMobileView);

  return useMutation({
    mutationFn: ({ recipientId }: CreatePrivateChatRequest) => {
      return createPrivateChat({ recipientId });
    },
    onMutate: () => {
      changeChatMobileView("chat");
    },
    onSuccess: (chat) => {
      setCurrentChat(chat);
      push("/platform/messages");
    },
  });
};

export { useCreatePrivateChat };
